import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { OrganizationService } from '../services/organization.service';

export const platformAdminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const organizationService = inject(OrganizationService);
  const router = inject(Router);

  await authService.checkSession();

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: '/admin' },
    });
  }

  const isAdmin = await organizationService.isPlatformAdmin();
  if (isAdmin) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};
